export const focusElement = elementRef => {
  if (elementRef && elementRef.current && elementRef.current.focus) {
    elementRef.current.focus();
  }
};
